import { cn } from "@/lib/utils";
import Image from "next/image";

export default function Maintenance() {
    return (
        <div
            className={cn(
                "flex min-h-[90vh] flex-col items-center justify-center p-8",
                "bg-background text-foreground",
                "transition-colors duration-200"
            )}
        >
            <div
                className={cn(
                    "flex max-w-[600px] flex-col items-center gap-8 text-center"
                )}
            >
                <div
                    className={cn(
                        "relative aspect-square w-full max-w-[400px]"
                    )}
                >
                    <Image
                        src="/img/under-maintenance.png"
                        alt="Under Maintenance"
                        fill
                        style={{ objectFit: "contain" }}
                        priority
                    />
                </div>

                <div className={cn("flex flex-col gap-4")}>
                    <h1
                        className={cn(
                            "m-0 text-[2rem] font-bold text-foreground",
                            "text-[1.5rem] md:text-[2rem]"
                        )}
                    >
                        서비스 점검 중입니다
                    </h1>

                    <p
                        className={cn(
                            `m-0 text-[1.125rem] leading-relaxed
                            text-muted-foreground`,
                            "text-base md:text-[1.125rem]"
                        )}
                    >
                        10월 24일 21시 ~ 25일 00시 동안 시스템 점검이 진행되고
                        있습니다.
                        <br />
                        잠시만 기다려 주세요!
                    </p>
                </div>
            </div>
        </div>
    );
}
